/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `annotation` - ANNOTATION * `ground_truth` - GROUND_TRUTH * `consensus_replica` - CONSENSUS_REPLICA
 * @export
 * @enum {string}
 */

export const JobType = {
    Annotation: 'annotation',
    GroundTruth: 'ground_truth',
    ConsensusReplica: 'consensus_replica'
} as const;

export type JobType = typeof JobType[keyof typeof JobType];



